import routes from './routes';
import { SetRoutes } from 'components';

const SalesTrackingsGenderBrandPages = () => {
  return (
    <>
      <SetRoutes routes={routes} />
    </>
  );
};

export default SalesTrackingsGenderBrandPages;
